import {Link} from "@nextui-org/react";
import React, {useEffect, useState} from "react";
import ApiService from "@/services/api-service";
import SharedServiceInstance from "@/services/shared-service";
import {FaAngleLeft, FaAngleRight} from "react-icons/fa";
import {MdPhotoLibrary} from "react-icons/md";
import ModalSliderAlbum from "@/components/shared/modal-slider-album";
import Swipe from "react-easy-swipe";

export default function Albums() {
    const [albums, setAlbums] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentAlbumPhotos, setCurrentAlbumPhotos] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [mobileAlbumIndex, setMobileAlbumIndex] = useState(0);
    const [pointer, setPointer] = useState(false);

    const fetchAlbumData = async () => {
        const data = await ApiService.getAlbums({top: 4, skip: 0, isCount: false, sort: "created desc"});
        if (data) {
            setAlbums(data);
        } else {
            setAlbums({});
        }
    }

    useEffect(() => {
        fetchAlbumData().then(r => {
        });
    }, [])

    const openAlbumModal = (photos, index = 0) => {
        setCurrentAlbumPhotos(photos);
        setCurrentIndex(index);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const goToNextAlbum = () => {
        if (!albums?.value?.length) return;
        setMobileAlbumIndex((prev) => (prev + 1) % albums.value.length);
    };

    const goToPrevAlbum = () => {
        if (!albums?.value?.length) return;
        setMobileAlbumIndex((prev) => (prev - 1 + albums.value.length) % albums.value.length);
    };

    useEffect(() => {
        if (!pointer) {
            const timer = setInterval(() => {
                goToNextAlbum();
            }, 5000);
            return () => clearInterval(timer);
        }
    }, [pointer, mobileAlbumIndex]);

    return (
        <div className="w-full bg-white flex flex-col justify-start gap-2 my-5 py-5">
            <div className="flex justify-start items-end gap-1 h-[30px] w-full">
                <h2 className="whitespace-nowrap text-primary font-bold text-3xl pt-5 pl-5">ALBUM</h2>
                <div className="flex w-full pb-2 pl-2">
                    <p className="h-[30px] w-full border-b-2 border-primary"></p>
                    <Link href="/album-hinh" className="min-w-fit text-primary">
                        <p className="text-md text-primary text-nowrap whitespace-nowrap mb-[-20px] pl-2 pr-5">Xem
                            thêm</p>
                    </Link>
                </div>
            </div>
            <div className="grid-cols-1 md:grid-cols-2 lg:grid-cols-4 grid gap-4 w-full h-full px-5">
                {/* layout desktop and tablet */}
                {albums?.value?.map((album, index) => (
                    <div key={index} className="hidden md:flex relative flex-col gap-2">
                        <div className="relative w-full aspect-[16/9] overflow-hidden">
                            <img
                                src={SharedServiceInstance.getOptimizeImage(album.photoUrls[0], "album")}
                                alt={album.name}
                                className="w-full h-full object-cover flex-shrink-0 cursor-pointer"
                                onClick={() => openAlbumModal(album.photoUrls)}
                            />
                        </div>
                        <div title={album.name}
                             className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/70 to-transparent text-white p-3 cursor-default"
                        >
                            <h3 className="lg:text-lg md:text-[14px] font-semibold truncate">{album.name}</h3>
                            <div className="flex items-center lg:text-sm md:text-small space-x-1">
                                <MdPhotoLibrary className="w-4 h-4 text-white"/>
                                <span className="lg:text-xs md:text-[10px]">{album.photoUrls?.length} ảnh</span>
                            </div>
                        </div>
                    </div>
                ))}

                {/* layout mobile */}
                {albums?.value?.length > 0 && (
                    <div onMouseEnter={() => setPointer(true)} onMouseLeave={() => setPointer(false)}
                         className="md:hidden w-full flex items-center justify-center relative">
                        <Swipe onSwipeLeft={goToNextAlbum} onSwipeRight={goToPrevAlbum} className="w-full">
                            <div className="relative w-full aspect-[16/9] overflow-hidden rounded-lg shadow-md">
                                <img
                                    src={SharedServiceInstance.getOptimizeImage(albums.value[mobileAlbumIndex]?.photoUrls[0], "album")}
                                    alt={albums.value[mobileAlbumIndex]?.name}
                                    className="w-full h-full object-cover cursor-pointer"
                                    onClick={() => openAlbumModal(albums.value[mobileAlbumIndex]?.photoUrls)}
                                />
                                <div
                                    title={albums.value[mobileAlbumIndex]?.name}
                                    className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/70 to-transparent text-white p-3 cursor-default"
                                >
                                    <h3 className="text-base font-semibold truncate">{albums.value[mobileAlbumIndex]?.name}</h3>
                                    <div className="flex items-center text-sm space-x-1">
                                        <MdPhotoLibrary className="w-4 h-4 text-white"/>
                                        <span>{albums.value[mobileAlbumIndex]?.photoUrls?.length} ảnh</span>
                                    </div>
                                </div>
                            </div>
                        </Swipe>

                        {/* Prev button*/}
                        <button
                            onClick={goToPrevAlbum}
                            className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white rounded-full p-2"
                        >
                            <FaAngleLeft className="text-lg"/>
                        </button>

                        {/* Next button*/}
                        <button
                            onClick={goToNextAlbum}
                            className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white rounded-full p-2"
                        >
                            <FaAngleRight className="text-lg"/>
                        </button>
                    </div>
                )}
            </div>
            {showModal && (
                <ModalSliderAlbum
                    selectedPhotos={currentAlbumPhotos}
                    currentIndex={currentIndex}
                    setCurrentIndex={setCurrentIndex}
                    closeModal={closeModal}
                />
            )}
        </div>
    )
}